import { render, staticRenderFns } from "./goodsTable.vue?vue&type=template&id=140091a6&scoped=true"
import script from "./goodsTable.vue?vue&type=script&lang=js"
export * from "./goodsTable.vue?vue&type=script&lang=js"
import style0 from "./goodsTable.vue?vue&type=style&index=0&id=140091a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140091a6",
  null
  
)

export default component.exports